import type { PriceInfo } from "../api/subscription";

const CURRENCY_LOCALE: Record<string, string> = {
  RUB: "ru-RU",
};

export const formatPrice = (amount: number, currency: string): string => {
  const curr = currency.toUpperCase();
  const locale = CURRENCY_LOCALE[curr] ?? "en-US";
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: curr,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${amount} ${currency}`;
  }
};

export const formatPriceInfo = (price: PriceInfo): string =>
  formatPrice(price.amount, price.currency);
